module.exports = __webpack_public_path__ + "static/accounting-008d3a682ef746e5198c3bfcbfecd1f6.png";